import { create } from 'zustand'
import type { UsuarioParceiroItem } from '@/types'
import * as parceirosApi from '@/api/parceiros'

interface UsuariosParceiroState {
  usuarios: UsuarioParceiroItem[]
  loading: boolean
  error: string | null
  fetchUsuarios: () => Promise<void>
  criarUsuario: (values: {
    nome: string
    email: string
    cpf: string
    role: 'admin' | 'operador'
  }) => Promise<{ usuarioId: number }>
  atualizarRole: (usuarioId: number, role: 'admin' | 'operador') => Promise<void>
  removerUsuario: (usuarioId: number) => Promise<void>
}

export const useUsuariosParceiroStore = create<UsuariosParceiroState>((set, get) => ({
  usuarios: [],
  loading: false,
  error: null,

  fetchUsuarios: async () => {
    set({ loading: true, error: null })
    try {
      const usuarios = await parceirosApi.getUsuariosParceiro()
      set({ usuarios, loading: false })
    } catch {
      set({ error: 'Erro ao carregar usuários', loading: false })
    }
  },

  criarUsuario: async (values) => {
    const resultado = await parceirosApi.criarUsuarioParceiro(values)
    await get().fetchUsuarios()
    return { usuarioId: resultado.usuarioId }
  },

  atualizarRole: async (usuarioId, role) => {
    await parceirosApi.atualizarRoleUsuarioParceiro(usuarioId, role)
    set((state) => ({
      usuarios: state.usuarios.map((u) =>
        u.usuarioId === usuarioId ? { ...u, role } : u,
      ),
    }))
  },

  removerUsuario: async (usuarioId) => {
    await parceirosApi.removerUsuarioParceiro(usuarioId)
    set((state) => ({
      usuarios: state.usuarios.filter((u) => u.usuarioId !== usuarioId),
    }))
  },
}))
